import { BounceZoomIn, FadeIn, BounceZoomOut, FadeOut } from 'slotworks/graphics/animation/base-animations';
import Layers from 'slotworks/graphics/layers/layers';
import { AbstractSceneTransition } from 'slotworks/graphics/layers/scene-transitions/abstract-scene-transition';
import GameState from 'slotworks/model/game-state';
import Contract from 'slotworks/utils/contract';
import { sequence, parallel } from 'slotworks/utils/race-utils';
import Timer from 'slotworks/utils/timer';
import * as TweenJS from 'slotworks/utils/tween';
import deviceInfo from 'slotworks/utils/device-info';
import soundManager from 'slotworks/sound/sound-manager';
import Components from 'slotworks/components/components';

export default class RetriggerFreeSpins extends AbstractSceneTransition {
    layers: any = [];
    private BOUNCE_TIME: number = 150;
    private OUT_TIME: number = 250;
    private glow: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract(resolve => {
            FadeIn(Layers.CelebrationBackground.getSprite('filter'), 400).execute();
            this.setValues();
            this.glow = Layers.CelebrationBackground.getSprite('DO_glow');
            this.glow.anchor.set(0.5, 0.5);
            this.glow.x += this.glow.width / 2;
            this.glow.y += this.glow.height / 2;
            const rotation = Math.PI / 64;
            this.glow.rotation = -rotation;
            
            BounceZoomIn(this.glow, this.BOUNCE_TIME).execute();
            BounceZoomIn(Layers.Prompts.container, this.BOUNCE_TIME)
                .then(() => {
                    new TweenJS.Tween(this.glow)
                        .to({ rotation }, 2000)
                        .repeat(Infinity)
                        .yoyo(true)
                        .start();
                    new TweenJS.Tween(this.glow)
                        .to({ alpha: 0.6 }, 200)
                        .repeat(Infinity)
                        .delay(100)
                        .yoyo(true)
                        .start();
                    Timer.setTimeout(() => {
                        resolve(null);
                    }, 1000);
                })
                .execute();

            if(!deviceInfo.isDesktop) {
                deviceInfo.onLayoutChange.add(this.onLayoutChange);
            }
        });        
    }

    private onLayoutChange = () => {
        const position = Layers.CelebrationBackground.getPosition("DO_glow");
        this.glow.position.set(position.x + position.width/2, position.y + position.height/2);
    }

    private setValues() {
        const valueText = Layers.Prompts.getBitmapText('value');
        const record = GameState.getCurrentGame().getCurrentRecord();
        valueText.text = record.freespinsWon.toString();
    }

    public out(): Contract<void> {
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.remove(this.onLayoutChange);
        }
        TweenJS.removeAll(this.glow);
        Components.matrix.idleSymbols();
        return parallel([
            () => sequence([
                () => BounceZoomOut(this.glow, this.OUT_TIME),
                () => Contract.wrap(() => { this.glow.visible = false; })]),
            () => sequence([
                () => BounceZoomOut(Layers.Prompts.container, this.OUT_TIME),
                () => Contract.wrap(() => {
                    Layers.Prompts.container.children.map(el => (el.visible = false));
                })
            ]),
            () => FadeOut(Layers.CelebrationBackground.getSprite('filter'), 400)
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/transitions/retrigger-freespins-transition.ts